import { useEffect, useState } from "react";
import PromptAuthorization from "../components/UserAnalytic/PromptAuthorization";
import UserAnalytic, { withUserAnalytic, TRACKING_STATUS } from "../helpers/UserAnalytic";

export const UserAnalyticRequest = ({
    userTrackingStatus
}) => {
    useEffect(() => {
        if (UserAnalytic.getTrackingStatus() === TRACKING_STATUS.YES) {
            UserAnalytic.startTracking();
        }
    }, [userTrackingStatus]);
    return (userTrackingStatus === TRACKING_STATUS.UNKNOWN ? <PromptAuthorization /> : null);
};

export default withUserAnalytic(UserAnalyticRequest);